jQuery.fn.headingFullWidth = function() {
  let self = this

  self.wrapInner('<span class="heading-full-width__inner">');
  var self_width = this.find('.heading-full-width__inner').outerWidth();
  var container_width = this.closest('.text-content').outerWidth();
  var self_fontsize = parseInt(self.css('font-size'));
  var window_size = $(window).width();
  var desired_fontsize = self_fontsize * container_width / self_width;
  var vw_size = desired_fontsize * 100 / window_size;
  self.css('font-size', vw_size + 'vw');

  return function() {
    return self
  }()
};
